<div class="row mb-1 mx-1 align-items-center" *ngIf="supplierDoc">
    <div class="col-2 d-flex justify-content-start">
        <label class="control-label" [ngClass]="{'text-warning':isExpired}" [paflabel]="getLblCod"></label>
    </div>
    <div class="col-4 d-flex justify-content-start align-items-center flex-row-reverse">
            <switchery-ios [(ngModel)]="OuiNon" size="small" name="TopFic" id="TopFic" [disabled]="readonly">
            </switchery-ios>
        <div class="flex-grow-1" *ngIf="supplierDoc.TopInputDescription==1 && supplierDoc.TopFic==1 && !supplierDoc.FullPath">
            <textarea class="form-control" [placeholder]="descriptionPlaceHolder() | async" *ngIf="supplierDoc.TopInputDescription==1 && supplierDoc.TopFic==1" style="height: 40px;width:100%;" name="description" [(ngModel)]="supplierDoc.Description" required [disabled]="readonly"></textarea>
        </div>
        <div class="flex-grow-1 align-self-center" *ngIf="supplierDoc.TopInputDescription==0 || supplierDoc.FullPath" [innerHTML]="getInformations | async"></div>
    </div>
    <div class="col-2" *ngIf="uploadProgress!=null">
        <kendo-progressbar [value]="uploadProgress"></kendo-progressbar>
    </div>
    <div *ngIf="showIsExpiredDate" class="control-label text-danger flex-grow-1">
        <paflabel lblCod="Expire_depuis"></paflabel> : {{supplierDoc.DateExpi | date : 'shortDate'}}
    </div>
    <div class="col-2 d-flex  align-items-start flex-nowrap" *ngIf="!(uploadProgress) && supplierDoc.TopFic==1">
        
        <div *ngIf="showExpiredAtDate" class="flex-grow-1">
            <paflabel lblCod="Expire_le"></paflabel> : {{supplierDoc.DateExpi | date : 'shortDate'}}
        </div>
        <div *ngIf="showDateControl" class="flex-grow-1 d-flex">
            <div class="mr-1 mt-1 text-primary" *ngIf="pafDocument.TopInputDat==1" [paftooltip]="getDateTooltip(pafDocument)">
                <i class="fas fa-info-circle"></i>
            </div>
            <div *ngIf="pafDocument.TopInputDat==1" class="mt-1 mr-1" [paflabel]="getDateLabel(pafDocument)"></div>
            <div *ngIf="pafDocument.TopInputDat==1" class="flex-shrink-0" style="width:115px;">
                <kendo-datepicker allowInput="true"
                    class="form-control"
                    [min]="minInputDate(pafDocument)"
                    [max]="maxInputDate(pafDocument)"
                    name="dateInput" 
                    style="width:100%;"
                    [(ngModel)]="dateInput" required></kendo-datepicker>
            </div>
        </div>
    </div>
    <div class="col-1">
        <div *ngIf="supplierDoc.TopFic==1 && (!(supplierDoc.FullPath) || isExpired) && !readonly">            
            <div class="file-upload">
                <button type="button" *ngIf="canUpload" class="btn btn-sm btn-primary" btnDebounceClick (debounceClick)="fileUpload.click()"  [paftooltip]="btnUploadTooltip" draganddrop (filesDropped)="onFilesDropped($event)"
                    [disabled]="readonly || !isDateValid">
                    <paflabel lblCod="Deposer"></paflabel>&nbsp;<i class="fas fa-paperclip"></i>
                </button>
                <input name="fileUpload" type="file" style="width:0px;" class="file-input" [accept]="requiredFileType"
                (change)="onFileSelected($event)" #fileUpload>
            </div>
        </div>
    </div>
    <div class="col-3 d-flex flex-row-reverse text-secondary align-items-center">
        <a class="flex-grow-1" *ngIf="showFilename" href="javascript:void(0);" btnDebounceClick (debounceClick)="btnDownloadFileClick()"
            [paftooltip]="'Telecharger_le_fichier'">{{getFilename}}</a>    
    </div>
</div>
<div *ngIf="emptySupplierDoc && !readonly">
    <supplier-qual-doc-row [lstPafDocuments]="lstPafDocuments" [lstDocTyps]="lstDocTyps" [lstDocStatuts]="lstDocStatuts" [isEmptyRowLine]="true" [supplier]="supplier" [supplierDoc]="emptySupplierDoc" [readonly]="readonly"  (reloadList)="emptyDocReset($event)"></supplier-qual-doc-row>
</div>
<pre *ngIf="sharedDatasSvc.debug && supplierDoc && (supplierDoc.DocId || 0)>0">
    {{supplierDoc | json}}
</pre>